import { useCallback } from 'react';
import { useCompanyPreferences } from './useCompanyPreferences';
import { formatCurrency as formatCurrencyUtil } from '../../../common/utils/currency';

function getCompanyId() {
  try {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const userObj = JSON.parse(storedUser);
      if (userObj?.company_id) return userObj.company_id;
    }
  } catch {
    // Ignore
  }
  return localStorage.getItem('company_id');
}

export function useFormatters(explicitCompanyId) {
  const companyId = explicitCompanyId || getCompanyId();
  const { preferences } = useCompanyPreferences(companyId);

  const currencyCode = preferences?.currency || 'INR';
  const locale = preferences?.language === 'en' ? 'en-IN' : 'en-IN'; // Fallback to en-IN for now since country-locale mapping can be complex

  const formatCurrency = useCallback(
    (value) => {
      return formatCurrencyUtil(value, currencyCode, locale);
    },
    [currencyCode, locale],
  );

  const formatNumber = useCallback(
    (value) => {
      if (value === null || value === undefined) return '0';
      const num = Number(value);
      if (isNaN(num)) return '0';
      return new Intl.NumberFormat(locale).format(num);
    },
    [locale],
  );

  const formatDate = useCallback(
    (dateString, options = {}) => {
      if (!dateString) return '-';
      const d = new Date(dateString);
      if (isNaN(d.getTime())) return '-';
      return d.toLocaleString(locale, options);
    },
    [locale],
  );

  return {
    formatCurrency,
    formatNumber,
    formatDate,
  };
}
